import React, { useState } from "react";
import ReactPlayer from "react-player";
import { Dialog } from "primereact/dialog";
import PropTypes from "prop-types";
import HfnImage from "../HfnImage";

function HfnVideoPlayer(props) {
  const {
    Title,
    Thumbnail,
    Video_Url: videoUrl,
    Popup,
    playing,
    loop,
    controls,
    volume,
    muted,
    playbackRate,
    width,
    pip,
    playIcon,
    Autoplay,
  } = props;

  const [show, setShow] = useState(false);

  return !Popup ? (
    <section className="HfnEmbedvideoplayer" id={Title}>
      <div className="HfnEmbed_wrapper">
        <ReactPlayer
          url={videoUrl}
          className="react-embed-player"
          light={Thumbnail ? <HfnImage {...Thumbnail} /> : false}
          playing={playing}
          loop={loop}
          controls={controls}
          volume={volume}
          muted={muted}
          playbackRate={playbackRate}
          pip={pip}
          width={width}
          playIcon={playIcon}
          autoPlay={Autoplay}
          style={{ width: "100px" }}
        />
      </div>
    </section>
  ) : (
    <section className="Hfnvideoplayer" id={Title}>
      <div className="Hfnvideoplayer_inner">
        <div
          onClick={() => setShow(true)}
          onKeyDown={() => setShow(true)}
          role="button"
          tabIndex="0"
          className="Hfnvideoplayer_play player-wrapper"
        >
          <HfnImage {...Thumbnail} />
          <i className="bi bi-play-circle" />
        </div>
      </div>
      <Dialog
        visible={show}
        onHide={() => setShow(false)}
        maximizable
        className="HfnPopup_wrapper"
      >
        <ReactPlayer
          url={videoUrl}
          className="react-player"
          playing={playing}
          loop={loop}
          controls={controls}
          volume={volume}
          muted={muted}
          playbackRate={playbackRate}
          pip={pip}
          width={width}
          playIcon={playIcon}
          autoPlay={Autoplay}
          style={{ width: "100px" }}
        />
      </Dialog>
    </section>
  );
}

HfnVideoPlayer.defaultProps = {
  playing: true,
  loop: true,
  Popup: false,
  controls: true,
  muted: false,
  playbackRate: 1,
  width: "100%",
  pip: false,
  playIcon: false,
  Autoplay: false,
  volume: 0.2,
};

HfnVideoPlayer.propTypes = {
  /**
   * Title is the Title for overall component
   * */
  Title: PropTypes.string.isRequired,
  /**
   * Thumbnail for the current video player
   * */
  Thumbnail: PropTypes.shape({
    data: PropTypes.shape({
      attributes: PropTypes.shape({
        name: PropTypes.string.isRequired,
        url: PropTypes.string.isRequired,
        alternativeText: PropTypes.string.isRequired,
        height: PropTypes.number.isRequired,
        width: PropTypes.number.isRequired,
      }).isRequired,
    }).isRequired,
  }).isRequired,
  /**
   * Url for the current video
   * */
  Video_Url: PropTypes.string.isRequired,
  /**
   * Popup needed for the current video
   * */
  Popup: PropTypes.bool,
  /**
   * Video is playable or not- True | false
   * */
  playing: PropTypes.bool,
  /**
   * Video is looped or not- True | false
   * */
  loop: PropTypes.bool,
  /**
   * Video has controls or not- True | false
   * */
  controls: PropTypes.bool,
  /**
   * Video is muted or not- True | false
   * */
  muted: PropTypes.bool,
  /**
   * Playspeed for video
   * */
  playbackRate: PropTypes.number,
  /**
   * width for video
   * */
  width: PropTypes.string,
  /**
   * Pip nebaled for video or not- True | false
   * */
  pip: PropTypes.bool,
  /**
   * Video has playIcon or not- True | false
   * */
  playIcon: PropTypes.bool,
  /**
   * Video is autoplayable or not- True | false
   * */
  Autoplay: PropTypes.bool,
  /**
   * Value for video volume ( Between 0 - 1 )
   * */
  volume: PropTypes.number,
};

export default HfnVideoPlayer;
